 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-05be0256":"1d330e08","chunk-0649d9bd":"788e4c2d","chunk-1393526d":"7af7b804","chunk-2a24524c":"e0e5ce49","chunk-6b2de988":"ed74e1df","chunk-278c5117":"b136c227","chunk-18a08199":"fdb9bf35","chunk-24570e6f":"f58a385d","chunk-2b318400":"4a8c9cf3","chunk-2f881f8c":"858a4a2b","chunk-345ed3c0":"86e27ef5","chunk-37a351da":"6595126e","chunk-39c23a2e":"b0049bcb","chunk-3bb53c2a":"f81b4cfc","chunk-3e3dcb38":"3b0d1cc1","chunk-3f7104b2":"c8321c06","chunk-3f9fda56":"ef4365e3","chunk-402f3906":"4ac2d100","chunk-43119659":"3440bd58","chunk-512a9056":"acf9f934","chunk-608cd238":"ead6ae9b","chunk-6be3efa2":"a0aae430","chunk-2e7e04d3":"44019d54","chunk-6fac3796":"5a426e1e","chunk-770bfbc4":"9eb2462f","chunk-797e284a":"d7a27c9f","chunk-866ce470":"056f62b3","chunk-a5825692":"4a33aa90","chunk-bd2bfc36":"6d9e5625","chunk-bd7d024a":"f98f8b59","chunk-c3b9a9ac":"7a4c0445","chunk-c88acd54":"4f5de7ec","chunk-e982a3b8":"4d0afe57","chunk-02abb509":"149cf33a","home":"ce7f72cc","chunk-3c7dacae":"ac35d632","chunk-afdab074":"862c6182","chunk-ff8859ca":"912646e6","explain":"02c3fc0d","feedback":"b2893537","switch":"dd162a17","transfer":"321df56c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05be0256":1,"chunk-0649d9bd":1,"chunk-2a24524c":1,"chunk-6b2de988":1,"chunk-278c5117":1,"chunk-18a08199":1,"chunk-24570e6f":1,"chunk-2b318400":1,"chunk-2f881f8c":1,"chunk-345ed3c0":1,"chunk-37a351da":1,"chunk-39c23a2e":1,"chunk-3bb53c2a":1,"chunk-3e3dcb38":1,"chunk-3f7104b2":1,"chunk-3f9fda56":1,"chunk-402f3906":1,"chunk-43119659":1,"chunk-512a9056":1,"chunk-608cd238":1,"chunk-2e7e04d3":1,"chunk-6fac3796":1,"chunk-770bfbc4":1,"chunk-797e284a":1,"chunk-866ce470":1,"chunk-a5825692":1,"chunk-bd2bfc36":1,"chunk-bd7d024a":1,"chunk-c3b9a9ac":1,"chunk-c88acd54":1,"chunk-02abb509":1,"home":1,"chunk-3c7dacae":1,"chunk-afdab074":1,"chunk-ff8859ca":1,"explain":1,"feedback":1,"switch":1,"transfer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-05be0256":"2cb9d4f0","chunk-0649d9bd":"f9fc3f01","chunk-1393526d":"31d6cfe0","chunk-2a24524c":"f1fa6c60","chunk-6b2de988":"1ee23cbf","chunk-278c5117":"31d8d188","chunk-18a08199":"f82d8ddf","chunk-24570e6f":"fb1f940f","chunk-2b318400":"9892967e","chunk-2f881f8c":"e2504dd0","chunk-345ed3c0":"11d8430a","chunk-37a351da":"e161af3a","chunk-39c23a2e":"dd26a35a","chunk-3bb53c2a":"2eee2ca4","chunk-3e3dcb38":"e1211fbb","chunk-3f7104b2":"8d645bc7","chunk-3f9fda56":"193ea74b","chunk-402f3906":"bb667e8f","chunk-43119659":"78f9e656","chunk-512a9056":"7d30e9be","chunk-608cd238":"6dc6c994","chunk-6be3efa2":"31d6cfe0","chunk-2e7e04d3":"dc0646b1","chunk-6fac3796":"840efaba","chunk-770bfbc4":"c81c9390","chunk-797e284a":"e4c359ba","chunk-866ce470":"e9418aba","chunk-a5825692":"0cf41b3c","chunk-bd2bfc36":"4ef59e7c","chunk-bd7d024a":"d5f60128","chunk-c3b9a9ac":"df67e0a1","chunk-c88acd54":"9a11d970","chunk-e982a3b8":"31d6cfe0","chunk-02abb509":"caf0cab6","home":"5caf2acf","chunk-3c7dacae":"46b044fd","chunk-afdab074":"64749887","chunk-ff8859ca":"f9340e9d","explain":"402efcbe","feedback":"6c450fae","switch":"3eef038d","transfer":"4e7530c8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
